import { render, staticRenderFns } from "./MdtPhoneNumberInput.vue?vue&type=template&id=5c76fd26&scoped=true"
import script from "./MdtPhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./MdtPhoneNumberInput.vue?vue&type=script&lang=js"
import style0 from "./MdtPhoneNumberInput.vue?vue&type=style&index=0&id=5c76fd26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c76fd26",
  null
  
)

export default component.exports